<div class="about-research-intro-wrapper container-fluid pt-lg-5">
    <div class="container-xxxl pt-4 mt-3 mt-lg-0">
        <div class="container-fluid pb-32">
            <div class="row">
                <h2 class="section-heading text-maroon border-maroon">{{ mainKA.title }}</h2>
            </div>
        </div>
        <p class="description fs-6 fs-lg-18 mb-lg-5" [innerHTML]="mainKA.bodyText"></p>

        <div class="d-print-none">
            <img [src]="imgUrl" [alt]="mainKA.images[0]?.altText" />
        </div>
    </div>
</div>
